<template>
    <div class="video-content">
        <!-- 左边 -->
        <div class="video-content-left"

        >
            <!-- 左边-内容区 -->
            <template v-if="videoUrl">
                <div class="pic-content-left-pic">
                    <video controls>
                        <source :src="videoUrl" type="video/mp4">
                        Your browser does not support the video element.
                    </video>

                </div>
            </template>
            <template v-else>
                <div class="video-content-left-content" @dragover.prevent @drop.prevent="handleDrop" @click="openFileInput">
                    <span style="font-size:25px; font-weight:bolder">请点击或拖拽上传视频</span>
                    <span
                        style="font-size:18px; margin-top:20px;width: 550px;text-align: center;">仅支持视频格式为：mp4、avi、mov、wmv、flv、mkv、webm</span>
                    <span style="font-size:18px;text-align: center;">大小限制为100MB，时长不超过30分钟
                    </span>
                    <input ref="fileInput" type="file"
                        accept="video/mp4, video/avi, video/mov, video/wmv, video/flv, video/mkv, video/webm"
                        class="file-input" style="display: none" @change="previewVideo" />
                </div>
            </template>
            <!-- 左边-底部 -->
            <div class="video-content-left-footer">
                <div class="video-content-left-footer-button">
                    <button class="footer-btn" @click="getExample()">样例</button>
                    <button class="footer-btn" @click="clearVideo()">清空视频</button>
                    <button class="footer-btn" @click="analyzeData()">视频分析</button>
                </div>
            </div>
        </div>
        <!-- 右边 -->
      <div class="video-content-right">
        <div v-if="isDetecting" class="top-button">
          <el-radio-group v-model="detect_mode" @change="handleChange">
            <el-radio-button label="视频伪造结果">
                <span>视频检测结果 <i v-if="scoreLoading" class="el-icon-loading" ></i></span>
            </el-radio-button>
            <el-radio-button label="人脸检测结果">
              <span>人脸检测结果 <i v-if="faceLoading" class="el-icon-loading" ></i></span>
            </el-radio-button>
            </el-radio-group>
        </div>

        <div
            v-if="!showFace"
            class="video-score"
             v-loading="loading"
             element-loading-background="#f9fbfe"
             element-loading-text="风险内容检测中……"
        >
          <template v-if="Object.keys(resultData).length > 0">
            <!-- 右边-上方 -->
            <div class="video-content-right-up">
              <div class="pic-content-right-up-text">
                <div class="pic-content-right-text-up"><span>视频由AI生成的可能性为：</span></div>
                <div class="pic-content-right-text-down">
                  <!--                              <countTo :class="{text_transition:this.resultData.power>70}" :startVal='0' :endVal='resultData.power' :suffix='"%"' :duration='600'></countTo>-->
                  <el-progress :width="150"  type="dashboard"  :percentage="60" :color="colors"></el-progress>

                </div>
              </div>
            </div>

            <div class="pic-content-right-down">

              <div class="pic-content-right-down-title">

                <div class="pic-content-right-down-error">
                  <span style="margin-bottom: 10px">视频内容信息:</span>

                  <span class="pic-text">
                        视频信息包含：XXXXXXXXXX
                        风险信息包含：XXXXXXXXXXXXXXXXXXXXX
                      </span>
                  <!--                      <span style="font-family: 'PingFang SC'"-->
                  <!--                            class="pic-text"-->
                  <!--                            v-for="(item, index) in resultData.messageList" :key="index">-->
                  <!--                                        <span> {{ item.desc }} </span>-->
                  <!--                                    </span>-->
                </div>


                <!--                    <div class="pic-content-right-down-success">-->
                <!--                      <span style="color:#00B050">检测内容正常</span>-->
                <!--                    </div>-->

              </div>
            </div>

            <!-- 右边-下方 -->
            <!--                <div class="video-content-right-down">-->
            <!--                    <template v-if="resultData.type === 'error'">-->
            <!--                        <div class="video-content-right-down-title">存在有害内容：</div>-->
            <!--                        <div class="video-content-right-down-list">-->
            <!--                            <div v-for="(item, index) in resultData.list" :key="index"-->
            <!--                                class="video-content-right-down-list-item">-->
            <!--                                <span class="video-content-right-down-list-item-content"> {{ item.time }} </span>-->
            <!--                                <span class="video-content-right-down-list-item-content"> {{ item.content }} </span>-->
            <!--                                <span class="video-content-right-down-list-item-content" style="color: #FF0000;"> {{-->
            <!--                                    item.label }} </span>-->
            <!--                            </div>-->
            <!--                        </div>-->
            <!--                    </template>-->
            <!--                    <template v-else-if="resultData.type === 'success'">-->
            <!--                        <div class="video-content-right-down-success">-->
            <!--                            <span>检测内容正常，不存在有害内容</span>-->
            <!--                        </div>-->
            <!--                    </template>-->

            <!--                  <template>-->
            <!--                    <div class="carousel-container">-->
            <!--                      <button v-if="showPrevButton" @click="prev" class="carousel-button left-button">‹</button>-->
            <!--                      <div class="carousel-wrapper">-->
            <!--                        <div class="carousel" :style="{ transform: `translateX(-${currentIndex * 100}%)` }">-->
            <!--                          <div v-for="(image, index) in images" :key="index" class="carousel-item"  @click="selectImage(index)">-->
            <!--                            <div :class="{ 'selected': selectedIndex === index }" class="image-wrapper">-->
            <!--                              <img :src="image.url" :alt="image.name" style="object-fit: contain"/>-->
            <!--                            </div>-->
            <!--                            &lt;!&ndash;                            <img :src="image.url" :alt="image.name" @click="singleFace(image.name)" />&ndash;&gt;-->
            <!--                          </div>-->
            <!--                        </div>-->
            <!--                      </div>-->
            <!--                      <button v-if="showNextButton" @click="next" class="carousel-button right-button">›</button>-->
            <!--                    </div>-->
            <!--                  </template>-->

            <!--                  <div class="form-area">-->
            <!--                    <el-row :gutter="20">-->
            <!--                      <el-col :span="9"><div class="score-area">人脸伪造分数:</div></el-col>-->
            <!--                      <el-col :span="15"><div class="score-area" style="font-weight: bolder">86%</div></el-col>-->

            <!--                    </el-row>-->

            <!--                    <el-row :gutter="20" style="height: 70%">-->
            <!--                      <el-col :span="9"><div style="font-size: 22px;font-weight: bolder">伪造区域Mask:</div></el-col>-->
            <!--                      <el-col :span="15"><el-image style="height: 200px;width:200px;" :src="mask_url" fit="contain"></el-image></el-col>-->

            <!--                    </el-row>-->
            <!--                  </div>-->

            <!--                  <div class="talker-video">-->
            <!--                    <span style="font-size: 25px;margin: 10px">说话人片段:</span>-->
            <!--                    <video v-if="videoUrl" style="width: 40%" controls>-->
            <!--                      <source :src="videoUrl" type="video/mp4">-->
            <!--                      Your browser does not support the video element.-->
            <!--                    </video>-->
            <!--                    <span style="font-size: 25px;margin: 10px">识别有害文本:</span>-->
            <!--                    <span style="font-size: 15px;margin: 10px;color: #bd2c00">XXXXXXXXXXXXXXX:<el-tag type="danger">诈骗</el-tag></span>-->
            <!--                    <div style="width: 100%;height: 100%">-->
            <!--                      <span style="font-size: 25px;margin: 10px">是否伪造:</span>-->
            <!--                      <el-tag type="danger">是</el-tag>-->
            <!--                    </div>-->
            <!--                  </div>-->
            <!--                  <div class="talker-video">-->
            <!--                    <span style="font-size: 25px;margin: 10px">说话人片段:</span>-->
            <!--                    <video v-if="videoUrl" style="width: 40%" controls>-->
            <!--                      <source :src="videoUrl" type="video/mp4">-->
            <!--                      Your browser does not support the video element.-->
            <!--                    </video>-->
            <!--                    <span style="font-size: 25px;margin: 10px">识别有害文本:</span>-->
            <!--                    <span style="font-size: 15px;margin: 10px;color: #bd2c00">XXXXXXXXXXXXXXX:<el-tag type="danger">诈骗</el-tag></span>-->
            <!--                    <div style="width: 100%;height: 100%">-->
            <!--                      <span style="font-size: 25px;margin: 10px">是否伪造:</span>-->
            <!--                      <el-tag type="danger">是</el-tag>-->
            <!--                    </div>-->
            <!--                  </div>-->
            <!--                  <div class="talker-video">-->
            <!--                    <span style="font-size: 25px;margin: 10px">说话人片段:</span>-->
            <!--                    <video v-if="videoUrl" style="width: 40%" controls>-->
            <!--                      <source :src="videoUrl" type="video/mp4">-->
            <!--                      Your browser does not support the video element.-->
            <!--                    </video>-->
            <!--                    <span style="font-size: 25px;margin: 10px">识别有害文本:</span>-->
            <!--                    <span style="font-size: 15px;margin: 10px;color: #bd2c00">XXXXXXXXXXXXXXX:<el-tag type="danger">诈骗</el-tag></span>-->
            <!--                    <div style="width: 100%;height: 100%">-->
            <!--                      <span style="font-size: 25px;margin: 10px">是否伪造:</span>-->
            <!--                      <el-tag type="success">否</el-tag>-->
            <!--                    </div>-->
            <!--                  </div>-->
            <!--                  <div class="talker-video">-->
            <!--                    <span style="font-size: 25px;margin: 10px">说话人片段:</span>-->
            <!--                    <video v-if="videoUrl" style="width: 40%" controls>-->
            <!--                      <source :src="videoUrl" type="video/mp4">-->
            <!--                      Your browser does not support the video element.-->
            <!--                    </video>-->
            <!--                    <span style="font-size: 25px;margin: 10px">识别有害文本:</span>-->
            <!--                    <span style="font-size: 15px;margin: 10px;color: #bd2c00">XXXXXXXXXXXXXXX:<el-tag type="danger">诈骗</el-tag></span>-->
            <!--                    <div style="width: 100%;height: 100%">-->
            <!--                    <span style="font-size: 25px;margin: 10px">是否伪造:</span>-->
            <!--                   <el-tag type="danger">是</el-tag>-->
            <!--                    </div>-->
            <!--                  </div>-->
            <!--                </div>-->
          </template>

        </div>
        <div class="pics-content"
             v-if="showFace"
             v-loading="faceLoading"
             element-loading-background="#f9fbfe"
             element-loading-text="人脸内容检测中……"
        >
          <div class="left-faces" >

            <div class="left-face" v-for="(item,index) in faces"
                 :key="index"
                 @click="selectFace(index)"
                 :class="{ active: selectedFace === index }"
            >
              <el-image lazy  style="width: 100%;height: 100%; object-fit: contain" :src="item.face">
                <div slot="placeholder" style="margin-top:30%;font-weight: bolder;font-size: 15px" >
                  加载中<i class="el-icon-loading"></i>
                </div>
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>

            </div>



          </div>


          <div class="form-area" style="height: 90%">
            <div class="face-mask">
              <div style="font-size: 25px;font-weight: bolder;margin-bottom: 10px">人脸区域截取视频:</div>
              <video controls style="width: 95%">
                <source :src="test_url" type="video/mp4">
                Your browser does not support the video element.
              </video>

              <div style="
                         margin-top: 20px;
                        font-size: 25px;
                        font-weight: bolder;
                        margin-bottom: 10px;"
              >人脸伪造分数: <countTo :class="{text_transition:this.score>70}" style="font-size: 35px" :decimals='1'  :startVal='0' :endVal='70' :suffix='"%"' :duration='600'></countTo></div>
            </div>

            <div class="pic-content-right-down-error" style="margin: 0">
              <span style="margin: 10px 0">人脸伪造区域信息:</span>
              <span style="font-family: 'PingFang SC'"
                    class="pic-text"
                    v-for="(item, index) in resultData.messageList" :key="index">

                                        <span> {{ item.desc }} </span>
                                    </span>
            </div>

          </div>



        </div>
      </div>

    </div>
</template>

<script>
import countTo from "vue-count-to";

export default {
  components: {countTo},
    data() {
        return {
          faces:[
              {face:require("@/assets/pic/face1.png")},
              {face:require("@/assets/pic/face1.png")},
              {face:require("@/assets/pic/face1.png")},
          ],
          showFace:false,
          scoreLoading :false,
          selectedFace:null,
          faceLoading:false,
          selectedIndex: null,
          currentIndex: 0,
          loading:false,
            videoUrl: '',
          test_url :"http://www.w3school.com.cn/example/html5/mov_bbb.mp4",
          selectedFile:null,
            resultData: {},
            isPics: true,
            textErrorSrc: require('@/assets/pic/error-robot.svg'),
            textSuccessSrc: require('@/assets/pic/text-success.png'),
            currentPicIndex: 0,
          detect_mode:"视频伪造结果",
          isDetecting:true,

          images: [
            { url: require('@/assets/pic/face1.png') , name: 'Image 1' },
            { url: require('@/assets/pic/face1.png'), name: 'Image 2' },
            { url: require('@/assets/pic/face1.png'), name: 'Image 3' },
            { url: require('@/assets/pic/face1.png'), name: 'Image 4' },
            { url: require('@/assets/pic/face1.png'), name: 'Image 5' },
            { url: require('@/assets/pic/face1.png'), name: 'Image 5' },
            // 其他图片数据
          ],

          colors: [

            {color: '#5cb87a', percentage: 40},
            {color: '#e5ca6f', percentage: 60},

            {color: '#ce5252', percentage: 80},
            {color: '#ec4c4c', percentage: 90},
            {color: '#f84141', percentage: 100}
          ],
        }
    },
    methods: {

      selectImage(index) {
        this.selectedIndex = index;
      },
      selectFace(index) {
        this.score =0
        this.selectedFace = index;
        console.log(index)
        this.mask_url = this.faces[index].mask
        this.score =   this.parseScore(this.faces[index].score)
        console.log(this.score)
      },
        openFileInput() {
           this.$refs.fileInput.click()
        },
        previewVideo(event) {
            const file = event.target.files[0];
            this.selectedFile = file
            const reader = new FileReader();
            reader.onload = (e) => {
                this.videoUrl = e.target.result;
            };
            reader.readAsDataURL(file);

            // 清除文件输入框的值，避免浏览器缓存
            event.target.value = '';
        },
      prev() {
        if (this.currentIndex > 0) {
          this.currentIndex--;
        }
      },
      next() {
        if (this.currentIndex < this.maxIndex - 1) {
          this.currentIndex++;
        }
      },
      handleDrop(event) {
        event.preventDefault();
        const file = event.dataTransfer.files[0];
        if (file && file.type.startsWith('video/')) {
          this.selectedFile = file;
          const reader = new FileReader();
          reader.onload = (e) => {
            this.videoUrl = e.target.result;
          };
          reader.readAsDataURL(file);
        }else {
          this.$message.error("请上传支持的视频格式文件")

        }
      },
      async uploadFile() {
        if (!this.selectedFile) {
          this.$message.warning('请先选择所需上传的文件');
          return;
        }
        try {
          this.loading = true
          // 使用 await 等待异步操作完成
          let timestamp = Date.now();
          const additionalData = { type: 'video', timestamp: timestamp };
          const resFile = await this.apis.uploadFile(this.selectedFile, additionalData);
          console.log(resFile.data.message);
          if (resFile.data.message === '文件上传成功') {
            this.$message.success('文件上传成功');
            this.videoAnalysis(timestamp);
          }
        } catch (error) {
          this.$message.error('文件上传失败');
          console.error('上传失败:', error);
        } finally {
          this.fileLoading = false;
          this.loading = false
        }
      },

         async analyzeData() {
           //发送视频给后台
           await this.uploadFile();
         },

      videoAnalysis(timestamp) {
        this.apis.videoAnalysis({
          type: 'video',
          fileName: this.selectedFile.name,
          fileTimestamp: timestamp
        })
            .then(res => {
              this.resultData = res;
            })
            .catch(err => {
              console.log()
              this.$notify.error({
                title: '系统错误，请联系管理员。',
                message: err
              });
            });
      },
        getExample() {
            this.videoUrl = require('@/assets/bg.mp4');
            //演示案例
            if (Object.keys(this.resultData).length === 0) {
                this.resultData = {
                    type: "error",
                    power: 88,
                    isAI: true,
                    list: [
                        {
                            id: "1",
                            time: "00:20:40-00:20:50",
                            content: "你们这些XX",
                            label: "暴力",
                        },
                        {
                            id: "2",
                            time: "00:48:40-00:55:50",
                            content: "杀人",
                            label: "血腥"
                        },
                        {
                            id: "3",
                            time: "01:15:20-01:25:30",
                            content: "抢劫",
                            label: "犯罪"
                        },
                        {
                            id: "4",
                            time: "01:45:10-01:55:25",
                            content: "毒品交易",
                            label: "违法行为"
                        },
                        {
                            id: "5",
                            time: "02:10:15-02:20:30",
                            content: "绑架",
                            label: "犯罪"
                        },
                        {
                            id: "6",
                            time: "02:35:40-02:45:50",
                            content: "斗殴",
                            label: "暴力"
                        },
                        {
                            id: "7",
                            time: "03:00:20-03:10:30",
                            content: "性侵",
                            label: "性暴力"
                        },
                        {
                            id: "8",
                            time: "03:25:10-03:35:25",
                            content: "贩卖人口",
                            label: "非法交易"
                        }

                    ],
                    pics: [
                        {
                            id: "1",
                            imageUrl: require('@/assets/pic/ai-1.png'),
                            time: "00:20:51"
                        },
                        {
                            id: "2",
                            imageUrl: require('@/assets/pic/ai-2.png'),
                            time: "00:25:33"
                        },
                        {
                            id: "2",
                            imageUrl: require('@/assets/pic/baoli.png'),
                            time: "00:25:33"
                        }
                    ]
                };
            }
            if (this.resultData.type === 'error') {
                this.resultData.type = 'success';
            } else {
                this.resultData.type = 'error';
            }
        },
      handleChange(value){
        if(value==="人脸检测结果"){
          this.showFace=true
        }else {
          this.showFace = false
        }

      },
        clearVideo() {
            this.videoUrl = '';
            //演示案例
            this.resultData = {};
        },
        getNextPic() {
            this.currentPicIndex += 1;
        },
        getLastPic() {
            this.currentPicIndex -= 1;
        },
        getMore() {
            this.isPics = true;
        },
        backHome() {
            this.isPics = false;
            this.isAI = true;
        }
    },
  computed:{
    showPrevButton() {
      return this.currentIndex > 0;
    },
    showNextButton() {
      return this.currentIndex < this.maxIndex;
    },

    maxIndex() {
      return this.images.length /3 ;
    },

  }
}
</script>

<style>
.video-content {
    display: flex;
    height: 70vh;
    background-color: #F9FBFE;
    width: 70vw;
    border-radius: 10px;
    padding: 20px;
}

.video-content-left {
    height: 100%;
    width: 50%;
    display: flex;
    flex-direction: column;
}

.video-content-left-pic {
    width: 100%;
    height: 90%;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
}
.talker-video {
  width: 100%;
  height: 55%;
}
.el-progress__text {
  font-size: 33px !important;
}


.video-content-left-content {
    height: 90%;
    width: 100%;
    border: 1px solid #5080ef;
    background-color: #ffffff;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    border-radius: 10px;
}
.top-button {
  display: flex;
  justify-content: center;
}
.file-input {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: auto;
    /* 调整为自动宽度 */
    height: 100%;
    /* 调整高度以匹配按钮 */
    opacity: 0;
    cursor: pointer;
}

video {
    width: 100%;
    margin: 0 auto;
    display: block;
    background-color: #f2f2f2;
    padding: 10px;
    border-radius: 10px;
}

.video-content-left-footer {
    height: 10%;
    width: 100%;
    display: flex;
    flex-direction: row-reverse;
    margin-top: 10px;
}

.video-content-left-footer-button {
    display: flex;
    flex-direction: row;
}


.video-content-right {
  height: 100%;
  width: 49%;
  margin-left: 1%;
}
.video-score {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;

}

.video-pics {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
}

.video-pics-title {
    width: 100%;
    height: 20%;
    font-size: 25px;
}

.video-pics-content {
    width: 100%;
    height: 80%;
    display: flex;
    flex-direction: row;
}

.video-pics-content-pic {
    width: 40%;
    height: 95%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-left: 50px;
}

.video-pics-content-text {
    height: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;

}

.video-pics-down {
    position: absolute;
    right: 0;
    bottom: 10px;
}

.video-content-right-up {
  margin: 40px 0 0 20px;
    height: 30%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    position: relative;
}

.video-content-right-up-pic {
    flex: 1;
    display: flex;
}

.video-content-right-up-text {
    flex: 4;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.video-content-right-text-up {
    font-size: 35px;
}

.video-content-right-text-down {
    margin-top: 30px;
    font-size: 50px;
}

.video-content-right-down {
    height: 70%;
    display: flex;
    flex-direction: column;
  overflow: auto;
}

.video-content-right-down-title {
    height: 10%;
    font-size: 25px;
    font-weight: 500;
}

.video-content-right-down-list {
    height: 80%;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    width: 100%;
}

.video-content-right-down-list-item {
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-around;

}

.video-content-right-down-list-item-content {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-weight: 600;
    height: 50px;
    width: 100%;
    margin: 5px;
    background-color: #5B9BD5;
    color: #FFFFFF;
}

.video-content-right-down-success {
    //height: 100%;
    font-size: 35px;
    font-weight: 500;

}</style>
